export const NPSatuses = [
    { title: "Очікують", value: 1, status: [1] },
    { title: "У дорозі", value: 8, status: [5] },
    { title: "У відділенні", value: 2, status: [7] },
    { title: "Отримані", value: 3, status: [9, 11] },
    { title: "Переадресовані", value: 10, status: [104] },
    { title: "Відмови", value: 4, status: [2, 102] },
    { title: "Форпости", value: 5, status: [10] },
    { title: "Повернення", value: 6, status: [9, 7, 8] },
    { title: "Доставка OLX", value: 7, status: [11, 9, 2, 3, 102] },
    { title: "Проблемні", value: 11, status: [104, 102, 105, 9] },
];

export const NPSatusesTitle = [
    { title: "Відправник самостійно створив цю накладну, але ще не надав до відправки", status: 1 },
    { title: "Видалено", status: 2 },
    { title: "Номер не знайдено", status: 3 },
    { title: "Відправлення у місті", status: 4 },
    { title: "Відправлення у місті", status: 41 },
    { title: "Відправлення прямує до міста", status: 5 },
    { title: "Прибув на відділення", status: 7 },
    { title: "Прибув на відділення (завантажено в Поштомат)", status: 8 },
    { title: "Відправлення отримано", status: 9 },
    {
        title: "Відправлення отримано. Протягом доби ви одержите SMS-повідомлення про надходження грошового переказу та зможете отримати його в касі відділення «Нова пошта»",
        status: 10,
    },
    { title: "Відправлення отримано. Грошовий переказ видано одержувачу.", status: 11 },
    { title: "Нова Пошта комплектує ваше відправлення", status: 12 },
    { title: "На шляху до одержувача", status: 101 },
    { title: "Відмова від отримання", status: 102 },
    { title: "Відмова одержувача", status: 103 },
    { title: "Змінено адресу", status: 104 },
    { title: "Припинено зберігання", status: 105 },
    { title: "Одержано і створено ЄН зворотньої доставки", status: 106 },
    { title: "Невдала спроба доставки через відсутність Одержувача на адресі або зв'язку з ним", status: 111 },
    { title: "Дата доставки перенесена Одержувачем", status: 112 },
];

export const getStatusTitle = (statusId, city) => {
    const title = NPSatusesTitle.filter((st) => st.status === +statusId)[0].title;
    if (statusId === 4 || statusId === 41 || statusId === 5) {
        title = title + ` ${city}`;
    }
    return title;
};
